module.exports = __webpack_public_path__ + "static/media/download.fa73c266.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/download.png
// module id = 284
// module chunks = 0